export const inlineBannerOverrideCss = "i1h35jap";
export const inlineBannerOverridePhoneCss = "i1sm35i7";
export const messageLayoutCss = "mm5vhqi";
export const babyBannerMessageLayoutCss = "b1ynt9on";
export const messageLayoutPhoneCss = "maifdof";
export const contentColumnCss = "c6z8or0";
export const headlineBlockCss = "h1w231dk";
export const titleRowCss = "t1wutz8i";
export const headlineTitleRowPopoverSpacingCss = "h4dj8gg";
export const messageTextCss = "m1ixnk0r";
export const aiTryItOutButtonCss = "ayfp32z";
export const babyBannerActionsRowCss = "b6g7rkz";

/** Scheduling-page banner: CTAs below headline (desktop left column) or full-width row (phone). */
export const schedulingPageBannerActionsRowCss = "s1q69s2c";
export const illustrationWrapperCss = "i1uil07g";
export const illustrationImageCss = "i1l6aanh";
export const buttonContainerCss = "bg96uzq";
export const babyAiAssistantPopoverContentCss = "b1li0ayb";
export const watchHowItWorksButtonContainerCss = "webz7wk";

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");